import { Schema, arrayOf } from 'normalizr'

export const school = new Schema('schools')
export const arrayOfSchoolsSchema = arrayOf(school)
